import { useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import DataSourceMngContext from '../../context/DataSourceMngContext';

const AlertSnackbar = ({
    autoHideDuration = 2000
}) => {

    const { alert, setDataState } = useContext(DataSourceMngContext);

    const handleClose = () => {
        setDataState((prevState) => ({
            ...prevState,
            alert: {
                ...prevState.alert,
                open: false
            }
        }));
    }

    return (
        <Snackbar
            open={alert.open}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}>
            <Alert
                severity={alert.severity}
                variant="filled"
                sx={{
                    width: '100%',
                    bgcolor: 'white',
                    borderRadius: '8px',
                    boxShadow: 7,
                    color: alert.severity === 'success' ? 'green' : 'red',
                }}>
                {alert.message}
            </Alert>
        </Snackbar>
    );
};

export default AlertSnackbar;